import { render, staticRenderFns } from "./payDetail.vue?vue&type=template&id=37788df4&scoped=true&"
import script from "./payDetail.vue?vue&type=script&lang=js&"
export * from "./payDetail.vue?vue&type=script&lang=js&"
import style0 from "./payDetail.vue?vue&type=style&index=0&id=37788df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37788df4",
  null
  
)

export default component.exports